import { useMutation } from '@tanstack/react-query';

import { createQuestion } from '../../../api/question/questionApi';

export function useCreateQuestion() {
  return useMutation({ mutationFn: createQuestion });
}
